<h2 class="title m-2">Accountable Function <em class="ti-close pull-right" style="color: red; cursor: pointer;" (click)="onClose()"></em> </h2>
<div class="title pull-right">
  <button class="default_secondary-btn relatives" (click)="onSubmit()">Add</button>
</div>
<div class="filter_search">
  <div class="search_container">
    <input type="text" class="default_input search search_land" placeholder="Search accountable function name"
    #name (keyup)="selectAccountableFxn(name.value)"/>
    <em class="ti-search"></em> 
  </div>
</div>

<table class="table table-hover">
  <thead>
    <tr>
      <th scope="col">S/N</th>
      <th scope="col">Accountable Function Name</th>
      <th scope="col">Function Name</th>
      <th scope="col">Functional Email</th>
      <th scope="col">Check</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let accountablefunction of accountablefunctionFormArray.get('AccountableFunctions')['controls']; index as i"
    matTooltip="Click on check box to add" aria-label="Button that displays a tooltip when focused or hovered over">
      <th scope="row">{{i + 1}}</th>
      <td>
        <div class="the_input">
          <span class="content">{{accountablefunction.value.AccountableFunctionName}}</span>
      </div>
    </td>
      <td>
        <div class="the_input">
          <span class="content">{{accountablefunction.value.FunctionName}}</span>
        </div>
      </td>
      <td>
        <div class="the_input">
          <span class="content">{{accountablefunction.value.FunctionalEmail}}</span>
        </div>
      </td>
      <td>
        <span class="content" (click)="$event.stopImmediatePropagation()">
          <input type="checkbox" style="cursor: pointer;" (click)="checkAccountableFunction(accountablefunction.value)" [checked]="checkSelected(accountablefunction.value.AccountableFunctionName)">
          <!-- <mat-checkbox style="cursor: pointer;" (click)="checkAccountableFunction(accountablefunction.value)" color="primary"></mat-checkbox> -->
        </span>
      </td>
    </tr>

  </tbody>
</table>

  
  <div class="box green_box"></div>
  <div class="box pink_box"></div>
  